module.exports = __webpack_public_path__ + "static/9-dd5dd8deae4cee9f0579347cbac682b2.jpeg";